import React                from "react";
import Styled               from "styled-components";
import NLS                  from "Dashboard/Core/NLS";

// Dashboard
import Icon                 from "Dashboard/Components/Common/Icon";



// Styles
const Empty = Styled.section`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px;
    height: var(--document-height);
`;

const Iconography = Styled(Icon)`
    margin-top: -40px;
    padding: 12px 24px;
    border-radius: var(--border-radius-big);
    background-color: var(--lighter-gray);
    color: var(--darkest-gray);
    opacity: 0.8;
`;

const Title = Styled.h3`
    font-size: 16px;
    font-weight: normal;
`;



/**
 * The Document Empty
 * @returns {React.ReactElement}
 */
function DocumentEmpty() {

    // Do the Render
    return <Empty>
        <Iconography icon="documents" size="72" />
        <Title>{NLS.get("DOCUMENTS_SELECT_ONE")}</Title>
    </Empty>;
}

export default DocumentEmpty;
